import React, { useMemo } from 'react';
import {
  AdoptionMaskBarIcon,
  Box,
  CardTypesEnum,
  costFormater,
  DCAPMaskBarIcon,
  FSAMaskBarIcon,
  HRAMaskBarIcon,
  HSAMaskBarIcon,
  LifestyleMaskBarIcon,
  ParkingMaskBarIcon,
  SpecialtyMaskBarIcon,
  Text,
  TransitMaskBarIcon,
} from '@common-fe/common-fe';
import styled from 'styled-components';

import { IAccountType, TotalClaimPayload } from '../EmployerDashboard.types';
const TitleWrapper = styled(Box)`
  transition: padding 0.15s ease-in-out;
`;
const BarWrapper = styled(Box)<BarWrapperProps>`
  background: ${({ theme, $type }) => theme.colors.cardTypes[$type]};
`;
interface BarWrapperProps {
  $type: CardTypesEnum;
}
const Wrapper = styled(Box)`
  transform: 0.35s;

  svg {
    transition: 0.35s;
    opacity: 0.05;
  }
  ${TitleWrapper} {
    padding-left: 0px;
  }
  &:hover {
    background: ${({ theme }) => theme.colors.border2};
    ${TitleWrapper} {
      padding-left: ${({ theme }) => theme.spacings.spacing12};
    }
    svg {
      opacity: 0.1;
    }
  }
`;

interface Props extends TotalClaimPayload {}

const MIN_VAL = 3;
const TotalSpendBar: React.FC<Props> = ({ percentage, planName, accountType, totalSpend, id }) => {
  const currentMask = useMemo(() => {
    if (accountType === IAccountType.HCFSA) {
      return <FSAMaskBarIcon />;
    }
    if (accountType === IAccountType.DCAP) {
      return <DCAPMaskBarIcon />;
    }
    if (accountType === IAccountType.HRA) {
      return <HRAMaskBarIcon />;
    }
    if (accountType === IAccountType.HSA) {
      return <HSAMaskBarIcon />;
    }
    if (accountType === IAccountType.ADOPTION) {
      return <AdoptionMaskBarIcon />;
    }
    if (accountType === IAccountType.LIFESTYLE) {
      return <LifestyleMaskBarIcon />;
    }
    if (accountType === IAccountType.PARKING) {
      return <ParkingMaskBarIcon />;
    }
    if (accountType === IAccountType.SPECIALTY) {
      return <SpecialtyMaskBarIcon />;
    }
    if (accountType === IAccountType.TRANSIT) {
      return <TransitMaskBarIcon />;
    }

    return <FSAMaskBarIcon />;
  }, [accountType]);

  const currentWidth = useMemo(() => {
    if (percentage <= MIN_VAL) return '8px';
    return `${percentage}%`;
  }, [percentage]);

  return (
    <Wrapper
      background="cavas"
      direction="row"
      align="center"
      round="checkboxRound"
      data-testid={`total-spend-bar_${id}_wrapper`}
      pad={{ left: '0', vertical: 'spacing6', right: 'spacing12' }}
    >
      <TitleWrapper width={{ min: '232px', max: '232px' }} margin={{ right: 'spacing16' }}>
        <Text
          data-testid={`total-spend-bar_${id}_title`}
          size="medium"
          weight={400}
          truncate
          title={planName}
        >
          {planName}
        </Text>
      </TitleWrapper>
      <Box direction="row" align="center" fill style={{ position: 'relative' }}>
        <BarWrapper
          width={currentWidth}
          direction="row"
          round="checkboxRound"
          $type={accountType as unknown as CardTypesEnum}
          style={{ overflow: 'hidden' }}
        >
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {currentMask}
            {currentMask}
          </div>
        </BarWrapper>
        <div>
          <Box pad={{ left: 'spacing12' }}>
            <Text data-testid={`total-spend-bar_${id}_value`} size="small" weight={500}>
              {costFormater(totalSpend, {
                isPrecision: true,
              })}
            </Text>
          </Box>
        </div>
      </Box>
    </Wrapper>
  );
};

export default TotalSpendBar;
